import { render, staticRenderFns } from "./MyWork.vue?vue&type=template&id=4212793a&scoped=true&"
import script from "./MyWork.vue?vue&type=script&lang=js&"
export * from "./MyWork.vue?vue&type=script&lang=js&"
import style0 from "./MyWork.vue?vue&type=style&index=0&id=4212793a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212793a",
  null
  
)

export default component.exports